import script from "./UnemployedDigitalSignatureForm.vue?vue&type=script&setup=true&lang=js"
export * from "./UnemployedDigitalSignatureForm.vue?vue&type=script&setup=true&lang=js"

import "./UnemployedDigitalSignatureForm.vue?vue&type=style&index=0&id=627f0af1&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-627f0af1"]])

export default __exports__